export const apiStatuses = {
    API_SUCCESS: 200,
    TEMP_REQUIRED: 307,
    API_CREATED: 201,
    API_DELETE: 204,
    MULTIPLE_RESPONSES: 300,
    BAD_REQUEST: 400,
    API_UNAUTHORISED: 401,
    FORBIDDEN: 403,
    API_DOES_NOT_EXIST: 404,
    UNABLE_PROCESS: 504,
    INTERNAL_SERVER_ERROR: 500
};

export const AlertsMsgs = {
    unAuthorized: "Unauthorized access! Please login to continue.",
    somethingWentWrong: "Something went wrong!",
};
